(() => {
  if (window.__tmPdpMotionControllerP0) return;
  window.__tmPdpMotionControllerP0 = true;

  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
  const saveData = navigator.connection?.saveData === true;
  const cards = new Set();
  let activeVideo = null;

  function loadCard(card) {
    if (!(card instanceof HTMLElement) || card.dataset.tmControllerLoaded === 'true') return;
    card.dataset.tmControllerLoaded = 'true';

    const image = card.querySelector('[data-tm-motion-image]');
    const imageSource = image?.dataset.tmMotionSrc;
    if (image instanceof HTMLImageElement && imageSource && !reducedMotion && !saveData) {
      image.src = imageSource;
      image.dataset.tmLoaded = 'true';
    }

    const video = card.querySelector('[data-tm-motion-video]');
    const source = video?.querySelector('source[data-src]');
    if (!(video instanceof HTMLVideoElement) || !(source instanceof HTMLSourceElement)) return;
    if (reducedMotion || saveData) {
      video.controls = true;
      video.addEventListener('pointerdown', () => loadVideo(video, source), { once: true });
      return;
    }
    loadVideo(video, source);
  }

  function loadVideo(video, source) {
    if (video.dataset.tmLoaded === 'true') return;
    source.src = source.dataset.src || '';
    source.removeAttribute('data-src');
    video.dataset.tmLoaded = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    try {
      video.load();
    } catch (_) {
      // The poster remains available if a browser refuses an early media load.
    }
  }

  function playCard(card) {
    const video = card.querySelector('[data-tm-motion-video]');
    if (!(video instanceof HTMLVideoElement)) return;
    if (card.dataset.tmAutoplay !== 'true' || reducedMotion || saveData) return;
    if (activeVideo && activeVideo !== video && !activeVideo.paused) activeVideo.pause();
    activeVideo = video;
    const play = () => {
      const promise = video.play();
      if (promise?.catch) promise.catch(() => {});
    };
    if (video.readyState >= 2) play();
    else video.addEventListener('canplay', play, { once: true });
  }

  function pauseCard(card) {
    const video = card.querySelector('[data-tm-motion-video]');
    if (video instanceof HTMLVideoElement && !video.paused) video.pause();
  }

  function observeCard(card) {
    if (!(card instanceof HTMLElement) || cards.has(card)) return;
    cards.add(card);
    const margin = Math.max(0, Math.min(400, Number(card.dataset.tmWarmupMargin) || 200));

    if (!('IntersectionObserver' in window)) {
      loadCard(card);
      playCard(card);
      return;
    }

    const warmObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        loadCard(card);
        warmObserver.disconnect();
      },
      { rootMargin: `${margin}px 0px` },
    );
    warmObserver.observe(card);

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.08) playCard(card);
          else pauseCard(card);
        }
      },
      { threshold: [0, 0.08, 0.35] },
    );
    visibilityObserver.observe(card);
  }

  function setup(root = document) {
    root.querySelectorAll?.('[data-tm-motion-card]').forEach(observeCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' && activeVideo && !activeVideo.paused) activeVideo.pause();
  });
})();
